(function () {
    "use strict";

    angular
        .module("app")
        .directive("documentList", ["$rootScope", "$uibModal", "DocumentService", "FileTypeExtImageUrl", "WebAPIUrl", "toaster", "SearchFactory", "PatternService", "QUtil", "cfpLoadingBar", documentList]);

    function documentList($rootScope, $uibModal, documentService, fileTypeExtImageUrl, webApiUrl, toaster, searchFactory, patternService, qUtil, cfpLoadingBar) {
        return {
            restrict: "E",
            link: function (scope) {

                var maxFileSize = 78643200; //75 MB

                scope.documentInterface = {};
                scope.documentList = [];
                scope.documentCategoryList = [];
                scope.validDocumentExtensions = ["doc", "txt", "xls", "pdf", "xlsx", "docx", "jpg", "jpeg", "gif", "png", "pptx", "zip", "rar", "msg", "xlsm", "ai", "ppt"];
                scope.FileTypeExtImageUrl = fileTypeExtImageUrl;

                var currentUser = $rootScope.globals.currentUser;

                scope.init = function () {
                    scope.clearUploadState();
                };

                scope.loadDocuments = function (projectId, projectLevelId) {
                    if (!projectId)
                        projectId = scope.projectId;
                    if (!projectLevelId)
                        projectLevelId = scope.projectLevelId;

                    if (!projectId || !projectLevelId) {
                        scope.documentList = [];
                        return;
                    }

                    documentService.getDocumentsList(projectId, projectLevelId).then(function (data) {
                        if (data !== "") {
                            angular.forEach(data, function (doc) {
                                var kb = (doc.FileSize / 1024).toFixed(2);
                                var mb = (kb / 1024).toFixed(2);
                                var size = mb === "0.00" ? (isNaN(kb) ? "N/A" : kb + " KB") : (isNaN(mb) ? "N/A" : mb + " MB");
                                doc.FileSize = size;
                                doc.DocumentUrl = scope.documentUrl(doc.DocumentId);
                                doc.selected = false;
                                // ReSharper disable once CoercedEqualsUsing
                                doc.CanDelete = !currentUser.isFactoryUser || doc.CreatedById == currentUser.userId;
                                doc.CanAddFactory = !currentUser.isFactoryUser;
                            });
                            scope.documentList = data;

                        } else {
                            scope.documentList = [];
                        }
                    });
                };

                scope.loadCategories = function (projectLevelId) {
                    if (!projectLevelId)
                        projectLevelId = scope.projectLevelId;

                    if (!projectLevelId) {
                        scope.documentCategoryList = [];
                        return;
                    }

                    documentService.getDocumentCategoryList(projectLevelId).then(function (data) {

                        scope.documentCategoryList = data;
                    });
                };

                scope.clearUploadState = function () {
                    scope.documentInterface = {};
                    var f = document.getElementById("documentFile");
                    if (f)
                        f.value = null;
                    scope.isApproved = null;
                    scope.isSelectAll = false;
                    scope.uploading = false;
                    scope.documentIndex = 0;
                    scope.progress = 0;
                    scope.filesUploaded = [];
                    scope.totalUploadSize = 0;
                    scope.uploadedSoFar = 0;
                    scope.showDocumentCategory = false;
                    scope.askIsApproved = false;
                    scope.uploadQueue = [];
                    scope.docArray = [];
                    scope.deleteArray = [];
                    scope.uploading = false;
                    scope.factoryKey = "";
                    scope.factoryName = "";
                    scope.factoryGroupKey = "";
                    scope.factoryGroupName = "";
                    scope.askIsFactory = false;
                    scope.showDocumentQueue = false;
                    scope.documentFactoryRemove = { document: {}, documentFactory: {} };
                };

                scope.onDocumentAdded = function (e) {
                    scope.showDocumentQueue = true;
                    function validateFile(file) {
                        var ext = file.name.substr(file.name.lastIndexOf(".") + 1).toLowerCase();
                        var errorMsg = "";

                        if (scope.validDocumentExtensions.indexOf(ext) === -1) {
                            errorMsg = "Invalid File Extension.";
                        }

                        if (file.size > maxFileSize) {
                            errorMsg = errorMsg + " File size is limited to 75 MB. ";
                        }

                        if (file.name.length > 175) {
                            errorMsg = errorMsg + " File name is over 175 characters, please rename your file and try again.";
                        }

                        if (errorMsg === "") {
                            return true;
                        }

                        file.error_flag = errorMsg.trim();
                        scope.showError(file.name + " - " + file.error_flag);
                        return false;
                    }

                    function queueFile(file) {
                        scope.docArray.push(file);

                        if (validateFile(file)) {
                            scope.uploadQueue.push(file);
                        } else {
                            scope.clearUploadState();
                        }
                    }

                    if (typeof e.files === "undefined") {
                        queueFile(e.file);
                    } else {
                        for (var i = 0; i < e.files.length; i++) {
                            queueFile(e.files[i]);
                        }
                    }

                    if (scope.uploadQueue.length === 0) {
                        scope.clearUploadState();
                    }

                    scope.showDocumentCategory = true;
                };

                scope.selectDocumentCategory = function (cat) {
                    scope.selectedCategory = cat;

                    if (cat.IsApprovalDocument && !currentUser.isFactoryUser) {
                        scope.startApproval();
                        return;
                    }
                    else if (scope.showFactory && cat.AllowFactorySelection) {
                        scope.startFactorySelection();
                        return;
                    }

                    scope.processQueue();
                };

                scope.startApproval = function () {
                    scope.showDocumentCategory = false;
                    scope.askIsFactory = false;
                    scope.askIsApproved = true;
                };

                scope.selectIsApproved = function (isApproved) {
                    scope.isApproved = isApproved;
                    if (scope.showFactory && scope.selectedCategory.AllowFactorySelection) {
                        scope.startFactorySelection();
                        return;
                    }
                    scope.processQueue();
                };

                scope.startFactorySelection = function () {
                    scope.showDocumentCategory = false;
                    scope.askIsApproved = false;
                    scope.askIsFactory = true;
                };

                scope.selectIsFactory = function (isFactory) {
                    if (!isFactory) {
                        scope.processQueue();
                        return;
                    }
                    scope.selectFactoryForDocument = true;
                    scope.showFactorySearch(function (item) {
                        //console.log('selected...');
                        //console.log(item);
                        scope.factoryKey = item.FactoryKey;
                        scope.factoryName = item.FactoryName;
                        scope.factoryGroupKey = item.FactoryGroupKey;
                        scope.factoryGroupName = item.FactoryGroupName;
                        scope.processQueue();
                    });
                };

                scope.showFactorySearch = function (onSelect) {
                    $rootScope.modalSearch = searchFactory.factorySearch(onSelect);
                    $rootScope.modalSearch.parameters[0].value = "";
                    $rootScope.modalSearch.searchResults = $rootScope.modalSearch.search();
                    $rootScope.modalSearch.showSearch();
                };

                scope.changeDocumentFactory = function (documentFactory) {
                    scope.selectFactoryForDocument = true;
                    scope.selectFactoryForDocumentFactory = documentFactory;
                    scope.showFactorySearch(function (item) {
                        //console.log('change document factory...');
                        //console.log(item);
                        documentService.changeDocumentFactory(documentFactory.DocumentId, documentFactory.FactoryKey, item.FactoryKey, item.FactoryName, item.FactoryGroupKey, item.FactoryGroupName)
                            .then(function () { scope.loadDocuments(); });
                    });
                };

                scope.askRemoveDocumentFactory = function (document, documentFactory) {
                    scope.documentFactoryRemove.document = document;
                    scope.documentFactoryRemove.documentFactory = documentFactory;
                    scope.documentFactoryRemove.removeDocumentFactory = scope.removeDocumentFactory;

                    scope.modal = $uibModal.open({
                        scope: scope,
                        templateUrl: templateUrl("app/directives/documents/documentList.removeFactory-modal.directive.html"),
                        backdrop: "static"
                    });

                };

                scope.removeDocumentFactory = function () {
                    documentService.removeDocumentFactory(scope.documentFactoryRemove.document.DocumentId, scope.documentFactoryRemove.documentFactory.FactoryKey).then(function () {
                        scope.loadDocuments();
                    });

                    scope.closeModal();
                };

                scope.processQueue = function () {
                    scope.uploading = true;
                    scope.askIsFactory = false;

                    var queue = scope.uploadQueue;

                    if (!queue || queue.length === 0) {
                        scope.clearUploadState();
                        return;
                    }

                    angular.forEach(queue, function (file) {
                        scope.totalUploadSize += file.size;
                    });

                    function onUploadProgress(e) {
                        if (e.lengthComputable) {
                            scope.progress = (((scope.uploadedSoFar + e.loaded) / scope.totalUploadSize) * 100).toFixed();
                            if (scope.progress > 100)
                                scope.progress = 100;
                        }
                    }

                    function processNext() {
                        scope.documentIndex++;
                        if (queue[scope.documentIndex]) {
                            uploadDocument(queue[scope.documentIndex]);
                        } else {
                            if (scope.filesUploaded.length > 0) {
                                scope.showSuccess(scope.filesUploaded.length + " - Document(s) Uploaded Successfully");

                                if (angular.isFunction(scope.onListChanged)) {
                                    scope.onListChanged();
                                }

                                if (scope.selectedCategory.AllowChildSelection) {
                                    if (scope.projectLevelId === 3) {
                                        scope.associateDocuments = angular.copy(scope.filesUploaded);
                                        scope.showPrototypeSelectModal(scope.associateDocuments[0]);
                                    }
                                }
                            }
                            scope.loadDocuments();
                            scope.clearUploadState();
                        }
                    }

                    function uploadDocument(file) {
                        var details = { ProjectId: scope.projectId, ProjLevDocCategoryId: scope.selectedCategory.ProjLevDocCategoryId, FactoryKey: scope.factoryKey, FactoryName: scope.factoryName, FactoryGroupKey: scope.factoryGroupKey, FactoryGroupName: scope.factoryGroupName, IsApproved: scope.isApproved };

                        //console.log('upload...');
                        //console.log(details);

                        documentService.uploadDocument(file, details, onUploadProgress).then(
                            function (result) {

                                scope.uploadedSoFar += file.size;

                                if (result.IsSuccessful) {
                                    scope.filesUploaded.push(result.Data);
                                }

                                processNext();
                            },
                            function (error) {
                                //console.log(error);
                                scope.uploadedSoFar += file.size;
                                scope.showError("There was an error while uploading the document. Please contact system administrator.");
                                processNext();
                            });
                    }

                    if (scope.selectedCategory) {
                        uploadDocument(queue[0]);
                    }
                };

                scope.deleteDocument = function () {
                    var ctx = {
                        counter: 0,
                        errorCounter: 0,

                        onComplete: function (success) {
                            ctx.counter++;

                            if (success === false)
                                ctx.errorCounter++;

                            if (scope.deleteArray.length === ctx.counter) {
                                scope.isSelectAll = false;
                                scope.loadDocuments();

                                scope.showSuccess((ctx.counter - ctx.errorCounter) + "/" + scope.deleteArray.length + " Document(s) successfully deleted");

                                if (ctx.errorCounter > 0)
                                    scope.showError(ctx.errorCounter + "/" + scope.deleteArray.length + " Document(s) were not successfully deleted");

                                scope.deleteArray = [];
                                cfpLoadingBar.complete();

                                if (angular.isFunction(scope.onListChanged)) {
                                    scope.onListChanged();
                                }
                            } else {
                                ctx.processNext();
                            }
                        },

                        processNext: function () {
                            var documentId = scope.deleteArray[ctx.counter];

                            documentService.deleteDocument(documentId)
                                .then(function () {
                                    ctx.onComplete(true);
                                }, function () {
                                    ctx.onComplete(false);
                                });
                        }
                    };

                    scope.closeModal();
                    cfpLoadingBar.start();
                    ctx.processNext();
                };

                scope.getSelected = function () {
                    scope.deleteArray = [];
                    scope.deleteArrayNames = [];
                    var numSelected = 0;
                    for (var i = 0; i < scope.documentList.length; i++) {
                        var doc = scope.documentList[i];
                        if (doc.selected) {
                            numSelected++;
                            scope.deleteArray.push(doc.DocumentId);
                            scope.deleteArrayNames.push(doc.DisplayFileName);
                        }
                    }
                    scope.isSelectAll = numSelected === scope.documentList.length;
                };

                scope.toggleSelectAll = function () {
                    scope.isSelectAll = !scope.isSelectAll;
                    angular.forEach(scope.documentList, function (itm) {
                        itm.selected = itm.CanDelete && scope.isSelectAll;
                    });
                    scope.getSelected();
                };

                scope.optionToggled = function () {
                    scope.isSelectAll = scope.documentList.every(function (itm) {
                        return itm.selected;
                    });
                    scope.getSelected();
                };

                scope.showDeleteModal = function () {
                    scope.getSelected();

                    if (scope.deleteArray.length > 0) {
                        scope.modal = $uibModal.open({
                            scope: scope,
                            templateUrl: templateUrl("app/directives/documents/documentList.delete-modal.directive.html"),
                            backdrop: "static"
                        });
                    }
                };

                scope.showPrototypeSelectModal = function (document) {
                    scope.patternPrototypes = null;
                    scope.associatedPrototypes = null;
                    scope.associateDocument = document;

                    qUtil.whenAll([
                        function () {
                            return patternService.getPatternPrototypes(scope.projectId, true).then(function (data) {
                                scope.patternPrototypes = data;
                            });
                        },
                        function () {
                            return documentService.getAssociatedPrototypes(document.DocumentId).then(function (data) {
                                scope.associatedPrototypes = _.map(data, function (d) { return d.PrototypeSeasonalId; });
                            });
                        }]).then(function () {
                            angular.forEach(scope.patternPrototypes, function (p) {
                                p.checked = _.contains(scope.associatedPrototypes, p.PrototypeSeasonalId);
                            });

                            scope.setPatternPrototypesAllChecked();
                        });

                    scope.modal = $uibModal.open({
                        scope: scope,
                        templateUrl: templateUrl("app/directives/documents/documentList.selectPrototypes-modal.directive.html"),
                        backdrop: "static",
                        size: "lg"
                    });
                };

                scope.savePrototypeAssociations = function () {
                    var ids = _.chain(scope.patternPrototypes).where({ checked: true }).map(function (p) { return p.PrototypeSeasonalId; }).value();

                    documentService.savePrototypeAssociations(scope.associateDocument.DocumentId, ids).then(function () {
                        scope.patternPrototypes = null;
                        scope.associatedPrototypes = null;

                        scope.associateDocuments = _.filter(scope.associateDocuments, function (a) { return a.DocumentId !== scope.associateDocument.DocumentId; });

                        scope.closeModal();

                        if (scope.associateDocuments.length > 0) {
                            scope.showPrototypeSelectModal(scope.associateDocuments[0]);
                            return;
                        }

                        scope.associateDocument = null;
                        scope.loadDocuments();
                    });
                };

                scope.patternPrototypesAllChange = function (checked) {
                    angular.forEach(scope.patternPrototypes, function (p) {
                        p.checked = checked;
                    });
                };

                scope.setPatternPrototypesAllChecked = function () {
                    if (scope.patternPrototypes) {
                        scope.patternPrototypes.allChecked = _.every(scope.patternPrototypes, function (p) { return p.checked; });
                    }
                };

                scope.closeModal = function () {
                    if (scope.modal) {
                        scope.modal.close();
                    }
                };

                scope.documentUrl = function (documentId) {
                    return webApiUrl + "api/Document/DownloadFile?documentId=" + documentId;
                };

                scope.$on("$dropletReady", function () {
                    if (angular.isFunction(scope.documentInterface.defineHTTPSuccess)) {
                        scope.documentInterface.defineHTTPSuccess([/2.{2}/]);
                        scope.documentInterface.useArray(true);
                    }
                });

                scope.$watchGroup(["projectId", "projectLevelId"], function (newValues) {
                    scope.loadDocuments(newValues[0], newValues[1]);
                    scope.loadCategories(newValues[1]);
                });

                scope.showSuccess = function (msg) {
                    toaster.pop({ type: "success", title: "Success!", body: msg, timeout: 5000 });
                };

                scope.showError = function (msg) {
                    toaster.pop({ type: "error", title: "Error!", body: msg, timeout: 5000 });
                };

                scope.timeConvert = $rootScope.timeConvert;
                scope.init();
            },
            scope: { projectId: "=", projectLevelId: "=", readOnly: "=", title: "@", showFactory: "@", hasEditPermission: "=", onListChanged: "&?", showAssociations: "@?" },
            templateUrl: templateUrl("app/directives/documents/documentList.directive.html")
        };
    }
})();

